import { FunctionComponent } from 'react';
import { Tooltip } from 'ui';
import Achievement, { Props as AchievementProps } from './Achievement';

interface Props extends AchievementProps {
  onClick(): void;
}

const AchievementButton: FunctionComponent<Props> = ({ isAchieved, name, onClick, ...rest }) => {
  return (
    <Tooltip
      placement="top"
      title={
        <div>
          {isAchieved ? (
            name
          ) : (
            <span>
              {name} <span className="Achievement-tooltip-notAchieved">| Not achieved</span>
            </span>
          )}
        </div>
      }
    >
      <button
        className="Achievement_button"
        aria-label={isAchieved ? name : `${name}| Not achieved`}
        onClick={onClick}
        tabIndex={0}
      >
        <Achievement isAchieved={isAchieved} name={name} {...rest} />
      </button>
    </Tooltip>
  );
};

export default AchievementButton;
